import {CommonData} from "../common/data.model";
import {PermissionsService} from "./permissions.service";

export class Permission extends CommonData {
  permission_type_id: string;
  pivot: UserTypePermission;

  static readonly OR_QUERY = 'or';
  public static readonly AND_QUERY = 'and';
}

export class UserTypePermission extends CommonData {
  account_user_type_id: string;
  permission_id: string;
}

export class CrudPermissions {
  list: CrudPermissionValue;
  view: CrudPermissionValue;
  add: CrudPermissionValue;
  edit: CrudPermissionValue;
  delete: CrudPermissionValue;

  constructor() {
    this.list = new CrudPermissionValue([]);
    this.view = new CrudPermissionValue([]);
    this.add = new CrudPermissionValue([]);
    this.edit = new CrudPermissionValue([]);
    this.delete = new CrudPermissionValue([]);
  }

  onList(permissions: CrudPermissionValue) {
    this.list = permissions;
    return this;
  }

  onAdd(permissions: CrudPermissionValue) {
    this.add = permissions;
    return this;
  }

  onView(permissions: CrudPermissionValue) {
    this.view = permissions;
    return this;
  }

  onEdit(permissions: CrudPermissionValue) {
    this.edit = permissions;
    return this;
  }

  onDelete(permissions: CrudPermissionValue) {
    this.delete = permissions;
    return this;
  }
}

export class CrudPermissionValue {
  constructor(public permissions: string[], public typeCondition: string = Permission.OR_QUERY) {
  }
}
